import {useCallback, useEffect, useState} from "react";
import {useOutletContext} from "react-router";
import {apiGet} from "../utils";
import {buildLegacyApiContext, hasDateFilters} from "../utils/filters";
import {RecoverableMarginSummary} from "../components/OpportunitySummary";
import {RecoverableMarginDetailTable} from "../components/OpportunityDetailTable";
import {LoadingPanel} from "../utils/loading_spinner";

export const OpportunityContainer = () => {
    const {filters} = useOutletContext();

    const [selectedLeak, setSelectedLeak] = useState(null);
    const [summaryData, setSummaryData] = useState(null);
    const [detailData, setDetailData] = useState([]);
    
    const [loading, setLoading] = useState(false);

    const fetchProfitLeaksData = useCallback(() => {
        if (!hasDateFilters(filters)) return;

        setLoading(true);
        const {period, queryParams} = buildLegacyApiContext(filters);

        apiGet(`calc/opportunity/summary/period/${period}${queryParams}`, (resp) => {
            if (resp.success) {
                setSummaryData(resp.data);
            } else {
                console.error('Summary API error:', resp.error);
                setSummaryData([]);
            }
            setLoading(false);
        });
    }, [filters]);

    useEffect(() => {
        fetchProfitLeaksData();
    }, [fetchProfitLeaksData]);

    const handleLeakSelect = (leak) => {
        setSelectedLeak(leak);
        
        if (leak && leak.subRows) {
            setDetailData(leak.subRows);
        } else {
            setDetailData([]);
        }
    };

    if (loading) {
        return <LoadingPanel loading={true} message="Loading recoverable margin analysis..." />;
    }

    return (
        <div style={{marginTop: 30, marginBottom: 100, marginLeft: 30, marginRight: 30}}>
            {/* Est. Recoverable Margin Table */}
            <div style={{marginBottom: 30}}>
                <RecoverableMarginSummary 
                    data={summaryData}
                    onRowSelect={handleLeakSelect}
                />
            </div>

            {/* Detail Table */}
            <RecoverableMarginDetailTable 
                data={detailData}
                selectedLeak={selectedLeak}
                loading={false}
            />
        </div>
    );
};